'use strict';

module.exports = {
    addToCart: function () {
        var isBuyNowJourney = false;
        $('body').on('product:beforeAddToCart', function (e, $this) {
            if ($($this).hasClass('buy-now') || $($this).hasClass('add-buy-now')) {
                isBuyNowJourney = true;
            } else {
                isBuyNowJourney = false;
            }
        });

        $('body').on('updateAddToCartFormData', function (e, form) {
            form.isBuyNowJourney = isBuyNowJourney;
        });

        $('body').on('product:afterAddToCart', function (e, data) {
            if (data.isBuyNowJourney) {
                window.location.href = data.redirectUrl;
            }
        });
    }
};
